var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flat-pickr',{staticClass:"timeNoBackground w-100",attrs:{"id":_vm.context.id,"config":{
      enableTime: true,
      dateFormat: 'H:i',
      time_24hr: true,
      noCalendar: true,
      enableSeconds: false,
      onOpen: _vm.setCurrentTime
    },"disabled":_vm.isDisabled},on:{"input":_vm.onChange},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }